module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/4-910f58d998703403168cbd84b8a4c3b6.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/4.mp3
// module id = 52
// module chunks = 0